<template>
  <div>
    <b-modal
      ref="openModal"
      v-model="isModalVisible"
      title="Editar Campos Pendentes"
      :ok-title="$t('geral.save')"
      :cancel-title="$t('geral.cancel')"
      @hidden="cancelModal"
      size="xl"
      scrollable
    >
      <!-- {{ selectedFields }} -->
      <b-form-group>
        <b-col>
          <b-row>
            <b-button class="my-2 my-sm-0" size="sm" @click="selectAll">
              {{ allSelected ? "Desmarcar Todos" : "Selecionar Todos" }}
            </b-button>

            <b-button
              v-if="selectedFields.length > 0"
              class="ml-2 my-sm-0"
              size="sm"
              @click="toggleSubModal()"
            >
              Editar selecionados
            </b-button>

            <!-- <b-button
              v-if="selectedFields.length > 0"
              @click="emptyAllCheckboxes()"
              size="sm"
              class="ml-2 my-sm-0"
            >
              Limpar seleções
            </b-button> -->
          </b-row>
        </b-col>
      </b-form-group>
      <!-- <pre class="language-json"><code>model: {{ items  }}</code></pre> -->
      <!-- :items="items" -->
      <b-table
        :items="items"
        :fields="tableFields"
        ref="tablePending"
        striped
        small
        hover
      >
        <template #cell(select)="{ item }">
          <b-form-checkbox
            :checked="checkItem(item)"
            @change="isSelected(item)"
          />
        </template>
      </b-table>

      <template #modal-footer="{}">
        <div style="text-align: right; width: 100%">
          <b-button class="ml-2" variant="danger" @click="cancelModal">
            Fechar
          </b-button>
        </div>
      </template>

      <!-- <pre class="language-json"><code>{{ items }}</code></pre> -->
      <!-- <pre class="language-json"><code>{{ selectedFields }}</code></pre> -->
    </b-modal>

    <form-pending-sub-modal
      ref="subModal"
      :selectedFields.sync="selectedFields"
      :optionsProfiles="optionsProfiles"
      :profiles="profiles"
      @close-modal="isModalVisible = false"
    />
  </div>
</template>

<script>
export default {
  name: "FormPendingModal",
  components: {
    FormPendingSubModal: () =>
      import("@/components_rms/checklist/form/FormPendingSubModal.vue"),
  },
  props: {
    items: {
      type: Array,
    },
    displayName: String,
    companyOptions: Array,
    profiles: Array,
    optionsProfiles: Array,
  },
  data() {
    return {
      tableItems: [],
      selectedFields: [],
      isModalVisible: false,
      tableFields: [
        {
          label: "",
          key: "select",
          sortable: false,
          thStyle: { width: "60px", padding: "0px" },
        },
        {
          label: "Nome",
          key: "nome",
          sortable: false,
          thStyle: { width: "200px" },
        },
        {
          label: "Tipo",
          key: "tipo",
          sortable: false,
          formatter: (value) => {
            const option = this.companyOptions.find(
              (option) => option.value === value
            );
            return option ? option.text : "";
          },
          thStyle: { width: "200px" },
        },
        {
          label: "Valor",
          key: "valor",
          sortable: false,
          thStyle: { width: "200px" },
        },
        {
          label: "Obrigatório",
          key: "obrigatorio",
          sortable: false,
          formatter: (value) => {
            const option = this.optionsBoolean.find(
              (option) => option.value === value
            );
            return option ? option.text : "";
          },
          thStyle: { width: "20px" },
        },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
    };
  },
  computed: {
    allSelected() {
      return this.areAllSelected();
    },
  },
  methods: {
    selectAll() {
      if (this.allSelected) {
        this.selectedFields = [];
      } else {
        this.selectedFields = [...this.items];
      }
    },

    onRowSelected(items) {
      console.log("onRowSelected");
      console.log(items);
      items.forEach((item) => {
        this.isSelected(item);
        this.$forceUpdate();
      });
    },
    checkItem(item) {
      let find = this.selectedFields.find((field) => field.id === item.id);
      if (find == undefined) {
        return false;
      } else {
        return true;
      }
    },
    isSelected(item) {
      let find = this.selectedFields.find((field) => field.id === item.id);
      if (find == undefined) {
        this.selectedFields.push(item);
      } else {
        this.selectedFields.splice(this.selectedFields.indexOf(item), 1);
      }
    },
    emptyAllCheckboxes() {
      this.selectedFields = [];
    },
    showModal() {
      this.$refs.openModal.show();
    },
    toggleSubModal() {
      this.$refs.subModal.showSubModal();
    },
    cancelModal() {
      this.selectedFields = [];
      this.$refs.openModal.hide();
    },
    areAllSelected() {
      return (
        this.items.length && this.items.length === this.selectedFields.length
      );
    },
  },
};
</script>
